var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#00AEEF",
      "clip-path": "url(#clip0)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.25 19.5c-1.601 0-3.025-1.025-3.542-2.551l-.035-.115C2.55 16.43 2.5 16.09 2.5 15.75V8.932L.074 17.03c-.312 1.191.399 2.426 1.592 2.755l15.463 4.141c.193.05.386.074.576.074.996 0 1.906-.661 2.16-1.635l.902-2.865H6.25zM9 9c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2z"
    }
  }), _c('path', {
    attrs: {
      "d": "M21.5 2h-15C5.122 2 4 3.122 4 4.5v11C4 16.878 5.122 18 6.5 18h15c1.378 0 2.5-1.122 2.5-2.5v-11C24 3.122 22.878 2 21.5 2zm-15 2h15c.276 0 .5.224.5.5v7.099l-3.159-3.686c-.335-.393-.82-.603-1.341-.615-.518.003-1.004.233-1.336.631l-3.714 4.458-1.21-1.207c-.684-.684-1.797-.684-2.48 0L6 13.939V4.5c0-.276.224-.5.5-.5z"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M0 0H24V24H0z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }